<template>
    <DropdownMenu>
        <DropdownMenuTrigger>
            <Button
                v-if="!selectedAppearance"
                class="gap-1 w-[214px] justify-between"
                variant="outline"
                >{{ $t("appearances.change") }}
                <ChevronDown :size="16" />
            </Button>
            <Button
                v-if="selectedAppearance"
                class="gap-1 w-[214px] justify-between"
                variant="outline"
            >
                {{
                    selectedAppearance.default
                        ? $t("appearances.default_theme")
                        : selectedAppearance.name
                }}
                <ChevronDown :size="16" />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuItem
                :class="[
                    appearance.id === selectedAppearance?.id
                        ? 'bg-stone-100'
                        : '',
                    'my-1 px-4 py-2',
                ]"
                v-for="appearance in appearances"
                :key="appearance.id"
                @click="handleClick(appearance)"
            >
                <AppearancePreview
                    :selected="appearance.id === selectedAppearance?.id"
                    :name="appearance.name"
                    :is-default="appearance.default"
                    :dark-mode="appearance.data.darkMode"
                    :primary-color="appearance.data.primaryColor"
                    :gray-color="appearance.data.grayColor"
                    :border-radius="appearance.data.borderRadius"
                >
                </AppearancePreview>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>

<script setup lang="ts">
import Button from "@/components/ui/button/Button.vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import AppearancePreview from "./AppearancePreview.vue";
import type { IAppearance } from "@/types/IAppearance";
import { ChevronDown } from "lucide-vue-next";

defineProps<{
    appearances: IAppearance[];
    selectedAppearance?: IAppearance;
}>();

const emit = defineEmits<{
    onSelected: [appearance: IAppearance];
}>();

function handleClick(appearance: IAppearance) {
    emit("onSelected", appearance);
}
</script>
